import React from 'react'
import GridCard from './GridCard'
import { Categories } from './Categories'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'


const Columns = ({ item,onClick }) => {
    return (
        <div className={`grid grid-flow-row lg:grid-cols-12 xl:grid-cols-12  w-full border-t`}>
            {item.columns && <div className={`${item?.columns?.length >= 3 ? "xl:grid-cols-3 lg:grid-cols-3  lg:col-span-6" : "xl:grid-cols-2 lg:grid-cols-2  lg:col-span-4"} grid-cols-2 grid grid-flow-row  gap-4 lg:p-4 xl:p-4 my-2 `}>
                {item.columns?.map((value, index) => {
                    return <div className='flex flex-col items-start justify-center my-2 ' key={index}>

                        <ul className='flex flex-col p-0 m-0 gap-2'>
                        <Link to={value.href} className='flex items-center justify-start font-bold' >{value.title}</Link>
                            {value.items && value.items?.map((i_, i) => {
                                return <li key={i} className='flex items-center justify-start  text-xs lg:text-sm xl:text-sm hover:text-[--color-button-3] transition-all duration-300'><Link to={i_.href} onClick={onClick} >{i_.label}</Link></li>
                            })}
                        </ul>
                    </div>
                })}
                
            </div>}
            {item.categories &&  <div className={`${(item?.columns?.length >= 3 || item?.columns?.length<=0 || !item?.columns)? "lg:col-span-6" : "lg:col-span-8"}  flex gap-2 items-center justify-end`}> <Categories item={item} onClick={onClick} /> </div>}

            <div className={`${item?.columns?.length >= 3 || item.categories ? "lg:col-span-6" : "lg:col-span-8"} grid grid-flow-row lg:grid-cols-6 xl:grid-cols-6 gap-2 items-center justify-end  lg:p-4 xl:p-4`}>
                {item.banners && item.banners?.map((value, index) => {
                    return <div key={index} className={`relative rounded-md overflow-hidden  ${index==0?"lg:col-span-2":"lg:col-span-4"}`}>
                        <span className='absolute top-5 lg:top-8 xl:top-8 left-5 block bg-[--color-button-1] px-[5px] py-[2px] rounded-md text-sm lg:text-base xl:text-base'>{value.title}</span>
                        <span className='absolute top-16 lg:top-20  xl:top-20  left-5'>{value.describe}</span>
                        <img src={value.link} alt={value.title} className='w-full ' />
                    </div>
                })}
                {item.colection && !item.colection?.isSlider && <div className='lg:col-span-6 xl:col-span-6 '> <GridCard item={item}  onClick={onClick}  /> </div>}
            </div>
        </div>
    )
}
export default Columns;